// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/breadcrumb/breadcrumb.scss
// module id = 516
// module chunks = 0